import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { motion } from 'framer-motion';
import styled from 'styled-components';
const Title = styled.h3 `
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  ${fonts.gillSans.semiBold};
  font-size: 18px;
  justify-content: center;
  letter-spacing: 0.1em;
  line-height: 28px;
  margin: 0 0 24px;
  padding: 0 0 12px;
  text-align: center;
  text-transform: uppercase;
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    background: ${cssVar('accentColor')};
    height: 2px;
    margin: 0;
    transform: translateX(-50%);
    width: 120px;

    @media ${until(Device.MobileLarge)} {
      width: 166px;
    }
  }

  @media ${from(Device.Tablet)} {
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;

    &::after {
      left: 0;
      transform: none;
      width: 110px;
    }
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 24px;
    line-height: 32px;
  }
`;
const TitleIcon = styled.span `
  display: block;
  height: 9px;
  width: 14px;
`;
const TitleIconWrapper = styled(motion.span) `
  display: inline-block;
  margin: 0 0 0 10px;
  transform-origin: center center;

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
export default {
    Title,
    TitleIcon,
    TitleIconWrapper,
};
